import React from "react";
import { FloatingBugButton } from "./FloatingBugButton";
import ThemeToggle from "../ThemeToggle";
import { PlusCircleIcon } from "@heroicons/react/24/outline";

type EntryMode = "wizard" | "snabb";

type Props = {
  onCreateTest?: () => void;
  email?: string | null;
  showEntryToggle?: boolean;
  entryMode?: EntryMode;
  setEntryMode?: (mode: EntryMode) => void;
};

export function TopBarActions({ onCreateTest, email, showEntryToggle, entryMode, setEntryMode }: Props): JSX.Element {
  return (
    <div className="flex items-center gap-2 p-2 ml-auto">
      {showEntryToggle && setEntryMode && (
        <div className="flex items-center gap-1 rounded-md border border-border bg-surface-2 px-1 py-1">
          <button
            type="button"
            className={`gw-btn gw-btn-sm ${entryMode === "wizard" ? "gw-btn-primary" : "gw-btn-ghost"}`}
            onClick={() => setEntryMode("wizard")}
            aria-pressed={entryMode === "wizard"}
          >
            Wizard
          </button>
          <button
            type="button"
            className={`gw-btn gw-btn-sm ${entryMode === "snabb" ? "gw-btn-primary" : "gw-btn-ghost"}`}
            onClick={() => setEntryMode("snabb")}
            aria-pressed={entryMode === "snabb"}
          >
            Snabb
          </button>
        </div>
      )}

      {onCreateTest && (
        <button
          type="button"
          className="gw-btn gw-btn-ghost"
          onClick={onCreateTest}
        >
          <PlusCircleIcon className="h-5 w-5" />
          <span className="hidden md:inline">Skapa testpost</span>
        </button>
      )}
      <FloatingBugButton inline label="Bugrapport" />
      <ThemeToggle />
      {email && (
        <div className="flex min-h-[36px] items-center rounded-md border border-border bg-surface-2 px-3 text-xs font-semibold text-text" aria-label="Inloggad användare">
          {email}
        </div>
      )}
    </div>
  );
}
